//引入上边封装的axios文件
import request from "@/request";
import qs from "qs"; 

// 普通订单获取分页
export const get_order_org = (data) => {
    return request({
        url: "/supplier/order/page?"+qs.stringify(data),
        method: "GET",
        headers:{
            "content-type": "application/json;charset=UTF-8"
        },
    });
};
// 普通订单导出
export const g_orderExport = (data) => {
    return request({
        url: "/supplier/order/export?"+qs.stringify(data),
        method: "GET",
        headers:{
            "content-type": "application/json;charset=UTF-8"
        },
    });
};
// 定制订单导出
export const cus_orderExport = (data) => {
    return request({
        url: "/supplier/cusOrder/export?"+qs.stringify(data),
        method: "GET",
        headers:{
            "content-type": "application/json;charset=UTF-8"
        },
    });
};
// 获取物流信息
export const getWLData = (data) => {
    return request({
        url: "/common/express/getExpressByNuCompany?"+qs.stringify(data),
        method: "GET",
        headers:{
            "content-type": "application/json;charset=UTF-8"
        },
    });
};

// 定制单获取分页
export const get_order_custom = (data) => {
    return request({
        url: "/supplier/cusOrder/page?"+qs.stringify(data),
        method: "GET",
        headers:{
            "content-type": "application/json;charset=UTF-8"
        },
    });
};
// 普通单详情
export const get_detail = (data) => {
    return request({
        url: "/supplier/order/detail?"+qs.stringify(data),
        method: "GET",
        headers:{
            "content-type": "application/json;charset=UTF-8"
        },
    });
};
// 普通单发货
export const send_order = (data) => {
    return request({
        url: "/supplier/order/deliver/"+data.id,
        method: "POST",
        headers:{
            "content-type": "application/json;charset=UTF-8"
        },
        data
    });
};
// 定制单发货
export const send_cusorder = (data) => {
    return request({
        url: "/supplier/cusOrder/deliver",
        method: "POST",
        headers:{
            "content-type": "application/json;charset=UTF-8"
        },
        data
    });
};
// 定制单报价
export const cusorder_price = (data) => {
    return request({
        url: "/supplier/cusOrder/quoteDetail",
        method: "POST",
        headers:{
            "content-type": "application/json;charset=UTF-8"
        },
        data
    });
};
// 定制单提交报价
export const submit_quote = (id) => {
    return request({
        url: "/supplier/cusOrder/submitQuoteV2/"+id,
        method: "POST",
        headers:{
            "content-type": "application/json;charset=UTF-8"
        }
    });
};
// 获取快递公司
export const get_express = () => {
    return request({
        url: "/common/expressCompany/list",
        method: "GET",
        headers:{
            "content-type": "application/json;charset=UTF-8"
        }
    });
};
// 普通订单备注
export const order_memo = (data) => {
    return request({
        url: "/supplier/order/supplierMemo",
        method: "POST",
        headers:{
            "content-type": "application/json;charset=UTF-8"
        },
        data
    });
};
// 定制单备注
export const custom_memo = (data) => {
    return request({
        url: "/supplier/cusOrder/supplierMemo",
        method: "POST",
        headers:{
            "content-type": "application/json;charset=UTF-8"
        },
        data
    });
};
// 普通单接单
export const recevie_order = (id) => {
    return request({
        url: "/supplier/order/receive/"+id,
        method: "POST",
        headers:{
            "content-type": "application/json;charset=UTF-8"
        },
    });
};
// 定制单详情
export const get_custom = (id) => {
    return request({
        url: "/supplier/cusOrder/detail/"+id,
        method: "GET",
        headers:{
            "content-type": "application/json;charset=UTF-8"
        },
    });
};





